import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { Checkbox } from '@getro/rombo';
import pluralize from 'pluralize';
import { ScrollBox } from 'components/atoms/ScrollBox';
import { MainSkeleton } from './skeletons';
import { ContactsCard } from './contactsCard';

export const ContactsCardView = ({
  queryParams,
  selectedRows,
  onChangeSelectedContact,
  onLoadMore,
  data,
  isLoading,
  isFetching,
  meta,
  filtersCount,
  activeNetwork,
  showAllContactsEmptyState,
  listId,
  showAddToLisButton,
  list,
  deleteContactFromList,
  bulkActions,
  page,
  isLoadingAI,
  handleSelectAll,
  listAction,
  type,
  disabledContacts,
  cardSx,
}) => {
  const showSkeleton = ((!isLoading && isFetching && queryParams.page === 1) || isLoadingAI) && queryParams.page === 1;
  const showListActions =
    !isLoadingAI && !isLoading && !isFetching && !showAllContactsEmptyState && meta?.queryTotal > 0;
  return (
    <ScrollBox
      overflowY={showSkeleton ? 'auto' : 'hidden'}
      id="contacts-card-view"
      sx={{ p: '12px 0px 0px 0px', height: 'calc(100vh - 106px)', ...cardSx }}
    >
      {(!showListActions || showSkeleton) && (
        <Text px="16px" fontSize="12px" color="text.subtle">
          Loading...
        </Text>
      )}
      {showListActions && (
        <Flex sx={{ alignItems: 'center', gap: '8px', px: '16px' }}>
          {listAction || (
            <Flex alignItems="center" justifyContent="space-between">
              <Checkbox checked={selectedRows.length === meta.queryTotal} onChange={handleSelectAll} />
              <Text fontSize="0">
                {`Showing ${!isLoading && isFetching && queryParams.page === 1 ? '-' : meta?.queryTotal} ${pluralize(
                  filtersCount ? 'results' : 'contacts',
                  meta?.queryTotal ?? 0,
                )}`}
              </Text>
            </Flex>
          )}
        </Flex>
      )}
      {showSkeleton && (
        <Box p="16px" height="initial">
          <MainSkeleton />
        </Box>
      )}
      {!showSkeleton && (
        <ContactsCard
          isLoading={isLoading}
          data={data}
          queryParams={queryParams}
          selectedRows={selectedRows}
          onChangeSelectedContact={onChangeSelectedContact}
          showAddToLisButton={showAddToLisButton}
          list={list}
          deleteContactFromList={deleteContactFromList}
          page={page}
          isLoadingAI={isLoadingAI}
          meta={meta}
          filtersCount={filtersCount}
          showAllContactsEmptyState={showAllContactsEmptyState}
          isFetching={isFetching}
          bulkActions={bulkActions}
          activeNetwork={activeNetwork}
          onLoadMore={onLoadMore}
          listId={listId}
          handleSelectAll={handleSelectAll}
          listAction={listAction}
          type={type}
          disabledContacts={disabledContacts}
        />
      )}
    </ScrollBox>
  );
};

ContactsCardView.defaultProps = {
  listId: null,
  showAddToLisButton: false,
  list: null,
  meta: null,
  deleteContactFromList: false,
  bulkActions: ['add-to-list', 'add-tag', 'export', 'delete', 'clear-selection'],
  listAction: null,
  type: 'default',
  disabledContacts: [],
  cardSx: {},
};

ContactsCardView.propTypes = {
  queryParams: PropTypes.shape({
    page: PropTypes.number,
    filters: PropTypes.object,
  }).isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeSelectedContact: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  meta: PropTypes.object,
  filtersCount: PropTypes.number.isRequired,
  activeNetwork: PropTypes.object.isRequired,
  showAllContactsEmptyState: PropTypes.bool.isRequired,
  listId: PropTypes.number,
  showAddToLisButton: PropTypes.bool,
  list: PropTypes.object,
  deleteContactFromList: PropTypes.bool,
  bulkActions: PropTypes.array,
  page: PropTypes.string.isRequired,
  isLoadingAI: PropTypes.bool.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  listAction: PropTypes.node,
  type: PropTypes.string,
  disabledContacts: PropTypes.array,
  cardSx: PropTypes.object,
};
